var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.257 12.1569C11.0314 13.1852 9.44153 13.806 7.70428 13.806C3.82794 13.806 0.685547 10.7154 0.685547 6.90299C0.685547 3.09057 3.82794 0 7.70428 0C9.44153 0 11.0314 0.620751 12.257 1.64903C13.4826 0.620751 15.0724 0 16.8097 0C20.686 0 23.8284 3.09057 23.8284 6.90299C23.8284 10.7154 20.686 13.806 16.8097 13.806C15.0724 13.806 13.4826 13.1852 12.257 12.1569Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2568 12.1569C13.766 10.8908 14.7229 9.0068 14.7229 6.90299C14.7229 4.79917 13.766 2.91516 12.2568 1.64903C13.4825 0.620751 15.0723 0 16.8095 0C20.6859 0 23.8283 3.09057 23.8283 6.90299C23.8283 10.7154 20.6859 13.806 16.8095 13.806C15.0723 13.806 13.4825 13.1852 12.2568 12.1569Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.257 12.1569C10.7479 10.8908 9.79102 9.00678 9.79102 6.90298C9.79102 4.79917 10.7479 2.91518 12.257 1.64905C13.7661 2.91518 14.723 4.79917 14.723 6.90298C14.723 9.00678 13.7661 10.8908 12.257 12.1569Z",
    fill: "#FF5E00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.e1aa0b694a815a809ca15c4d6d27fe01.svg";
export { ForwardRef as ReactComponent };